// Escape user-controlled text before interpolating it into an HTML string.
//
// The Google Maps info window is built as a raw HTML string and rendered with
// `v-html` (MapView.vue), which bypasses Vue's normal text interpolation and its
// automatic escaping. Field names are free-text, saved to the Realtime Database
// unsanitized, so a field named `<img src=x onerror=...>` would otherwise
// execute in the app origin -- the same origin holding the Firebase session in
// localStorage.
//
// `&` MUST be replaced first, otherwise the entities emitted by the later
// replacements get double-escaped (`<` -> `&lt;` -> `&amp;lt;`).
//
// This module is authored as CommonJS on purpose: the Vue build consumes it via
// `import { escapeHtml } from '.../escapeHtml'` (webpack interops named imports
// from CommonJS), and `node --test` can `require()` the very same file, so the
// unit test exercises the real implementation instead of a copy.
'use strict';

function escapeHtml (value) {
  if (value === null || typeof value === 'undefined') return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

module.exports = escapeHtml;
module.exports.escapeHtml = escapeHtml;
module.exports.default = escapeHtml;
